import { OnlineOfflineStatusApi, UserApi } from 'api-typings/users/users';
import { transformProfileViewUsers } from '../profile-view-users/profile-view-users.transformers';
import { transformUserImage } from '../users/users.transformers';
import { SearchUser } from './search-users.model';

export function transformSearchUser(user: UserApi): SearchUser {
  if (!user.reputation) {
    throw new ReferenceError('Missing a required reputation field.');
  }

  return {
    ...transformProfileViewUsers(user),
    avatar: user.avatar_cdn ? transformUserImage(user.avatar_cdn) : undefined,
    isOnline:
      user.online_offline_status !== undefined &&
      user.online_offline_status.status === OnlineOfflineStatusApi.ONLINE,
    rating: user.reputation.entire_history.overall,
    reviews: user.reputation.entire_history.reviews,
  };
}
